module.exports = __webpack_public_path__ + "static/media/CS2 -- Affinity Mapping.a691e736.png";